// src/extenders/klaviyo-sign-up.js
var KlaviyoSignUp = class extends HTMLElement {
  constructor() {
    super();
    this.signUpForm = this.querySelector("form");
    this.formOverlaySuccess = this.querySelector(".form-overlay--success");
    this.formOverlayError = this.querySelector(".form-overlay--error");
    this.companyId = this.getAttribute("data-section-id");
    this.listId = "W4JPhh";
    this.bindEvents();
  }
  bindEvents() {
    this.signUpForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const email = this.signUpForm.querySelector('input[type="email"]');
      if (email.validity.valid) {
        this.sendSubscribeRequest(email.value);
      }
    });
  }
  async sendSubscribeRequest(email) {
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email
                // Use the email collected from the input
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: this.listId
              // Use the dynamic list ID
            }
          }
        }
      }
    };
    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=Umbs9D`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Revision": "2024-06-15"
          },
          body: JSON.stringify(payload)
        }
      );
      console.log("Response status:", response.status);
      if (response.status === 202) {
        this.showOverlay(this.formOverlaySuccess);
      } else {
        const responseBody = await response.text();
        try {
          const json = JSON.parse(responseBody);
          console.log("Response body:", json);
        } catch (e) {
          console.log("Response body is not JSON:", responseBody);
        }
        this.showOverlay(this.formOverlayError);
      }
    } catch (error) {
      console.error("Error during subscription:", error);
      this.showOverlay(this.formOverlayError);
    }
  }
  showOverlay(overlay) {
    overlay.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      overlay.setAttribute("aria-hidden", "true");
    }, 5e3);
  }
};
if (!customElements.get("klaviyo-sign-up")) {
  customElements.define("klaviyo-sign-up", KlaviyoSignUp);
}
